<template>
  <header class="portal-header portal-header--home">
    <div class="portal-header__inner portal-header__inner--home">
      <router-link to="/" class="portal-brand">
        <img class="portal-brand__logo" :src="logoSrc" alt="全国社会艺术水平等级考试标识">
        <div class="portal-brand__text">
          <div class="portal-brand__line">
            <strong>全国社会艺术水平等级考试</strong>
            <span class="portal-brand__subtitle">考试查询服务</span>
          </div>
        </div>
      </router-link>
    </div>
  </header>
</template>

<script>
import logoSrc from '@/assets/logo.png'

export default {
  name: 'PortalHeader',
  props: {
    isHome: {
      type: Boolean,
      default: false
    },
    navItems: {
      type: Array,
      default: () => []
    },
    session: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      logoSrc
    }
  }
}
</script>
